export const GENE_TYPES = {
  VOLCANO: 'volcanoGenes',
  VIOLIN: 'expressionGenes',
};
